import styled from '@mint-lib/styled';

import Box from '../../components/Box/Box.jsx';

export const StyledDayPickerWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'bgColor',
})<{
  variant: 'single' | 'range';
  sidebar?: boolean;
}>`
  // root styles

  background-color: ${({ theme }) => theme.palette.ui.primary};
  box-shadow: 0 2px 12px 0px rgba(34, 37, 43, 0.24);
  border: ${({ theme }) => `1px solid ${theme.palette.border.tertiary}`};
  border-radius: 4px;
  margin-top: 4px;
  z-index: 1;

  display: flex;
  box-sizing: border-box;
  height: 336px;

  .rdp-months {
    width: ${({ variant }) => (variant === 'range' ? '523px' : '252px')};
    display: ${({ variant }) => (variant === 'range' ? 'grid' : 'block')};
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ variant }) => (variant === 'range' ? '9px' : '0')};
    position: relative;
    padding-bottom: 4px;
  }
  .rdp-months::after {
    display: ${({ variant }) => (variant === 'range' ? 'block' : 'none')};
    content: '';
    position: absolute;

    left: 261px;
    width: 1px;

    height: 100%;
    background-color: ${({ theme }) => theme.palette.border.secondary};
  }

  .rdp-dropdowns {
    display: grid;
    justify-content: center;
    grid-template-columns: ${({ variant }) =>
      variant === 'range' ? ' 55% 83px' : '145px 83px'};
    gap: 8px;
  }

  .rdp-month {
    width: ${({ variant }) => (variant === 'range' ? '257px' : '252px')};
    height: 280px;
  }

  .rdp-month_caption {
    padding: ${({ variant }) =>
      variant === 'range' ? '8px 0 4px 0' : '8px 8px 4px 8px'};
  }
  .rdp-month_grid {
    width: 252px;
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 4px 8px 0 8px;
  }

  .rdp-week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
  }
  .rdp-weeks {
    display: grid;
    gap: 2px;
  }

  .rdp-weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
  }

  .rdp-week_number {
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .rdp-weekday {
    justify-content: center;
    align-items: center;
    display: flex;
    width: 32px;
    height: 32px;
    color: ${({ theme }) => theme.palette.text.primary};
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 16px;
  }
  .rdp-day {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 4px;

    & > button {
      width: 32px;
      height: 32px;
      border: none;
      outline: none;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      padding: 0 !important;
      color: ${({ theme }) => theme.palette.text.primary};
      font-family:
        -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 16px;
    }
    &:hover {
      border: none;
      color: ${({ theme }) => theme.palette.tertiary.contrastText};
      background-color: ${({ theme }) => theme.palette.ui.hover};
    }
  }

  .rdp-selected {
    color: ${({ theme }) => theme.palette.tertiary.contrastText};
    background-color: ${({ theme }) => theme.palette.tertiary.main};
    border-radius: 4px;
    border: none;

    & > button {
      color: ${({ theme }) => theme.palette.tertiary.contrastText};
    }
    &:hover {
      border: none;
      color: ${({ theme }) => theme.palette.tertiary.contrastText};
      background-color: ${({ theme }) => theme.palette.tertiary.main};
    }
  }

  .rdp-range_middle {
    background-color: ${({ theme }) => theme.palette.ui.highlight};
    color: ${({ theme }) => theme.palette.tertiary.dark};
    &:hover {
      background-color: ${({ theme }) => theme.palette.ui.highlight};
      color: ${({ theme }) => theme.palette.tertiary.dark};
    }
    & > button {
      color: ${({ theme }) => theme.palette.tertiary.dark};
    }
  }

  .rdp-disabled {
    background-color: ${({ theme }) => theme.palette.ui.secondary};
    & > button {
      color: ${({ theme }) => theme.palette.action.disabled01};
    }
  }

  .rdp-today {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  .rdp-today:after {
    content: '';
    display: block;
    position: absolute;
    width: 8px;
    height: 4px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.tertiary.light};
    margin-bottom: 3px;
  }
  .rdp-day.rdp-event-days_style {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .rdp-day.rdp-event-days_style:after {
    content: '';
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 2px;

    background-color: ${({ theme }) => theme.palette.tertiary.light};
  }

  .rdp-outside {
    color: ${({ theme }) => theme.palette.action.disabled01};
  }

  .rdp-disabled {
    cursor: revert;
  }

  .rdp-hidden {
    visibility: hidden;
  }
`;
